import React from 'react';
import { GenericEntry } from '../..';
import { PulseSurveyActions } from '../../../../../entities/ApplicationFeed';
import { User } from '../../../../../entities/User';
import { Application } from '../../../../../entities/Application';
import { AlertObject } from '../../../../../components/Alert';

interface PropTypes {
  application: Application;
  currentUser: User;
  entry: PulseSurveyActions;
  isLastItemInPage: boolean;
  setAlert: (data: AlertObject) => void;
  reloadFeed: () => void;
}

export function PulseSurveySentEntry(props: PropTypes) {
  return (
    <GenericEntry
      icon='bi-file-earmark-bar-graph'
      iconClassName='bg-green-light'
      title={
        <>
          Pulse <strong>{props.entry.ceSurveyName || 'survey'}</strong> sent to{' '}
          <strong>{props.application.candidate.name}.</strong>
        </>
      }
      date={props.entry.createdAt}
      {...props}
    />
  );
}
